import 'angular';
import 'jquery';
import accordion from 'angular-ui-bootstrap/src/accordion';
import modal from 'angular-ui-bootstrap/src/modal';
// SearchJS dependencies
import '../../../../../lib/assets/javascripts/devex/urls';
import '../../../../../lib/assets/javascripts/devex/browser_url';
import '../../../../../lib/assets/javascripts/devex/search/sorting';
import '../../../../../lib/assets/javascripts/devex/search/filter';
import '../../../../../lib/assets/javascripts/devex/search/pagination';
import '../../../../../lib/assets/javascripts/devex/search/searchJS';
import '../services/url_handling.service';
import './search_bar.directive';
import './visualizations_button.directive';
import '../components/visualizations_container.component';
// Import modals' template
import template from './container.template.html?raw';
import searchTipsModalTemplate from '../modals/search_tips_modal.template.html?raw';
import terminologiesModalTemplate from '../modals/terminologies_modal.template.html?raw';
import '../services/report_api.service';
// Bookmarked searches directives dependencies
import 'angular-resource';
import '../../../../../lib/assets/javascripts/devex/alerts';
import '../../../../../lib/assets/javascripts/devex/angular/request_transformers';
import '../../../../../lib/assets/javascripts/devex/angular/filters/my_alert';
import '../../../../../lib/assets/javascripts/devex/angular/filters/bookmarked_search_ownership';
import '../models/bookmarked_search_service';
import '../../../../../lib/assets/javascripts/devex/angular/models/bookmarked-search';
import './bookmarked_searches/bookmarked_searches';
import './bookmarked_searches/bookmarked_searches_list';
import './bookmarked_searches/bookmarked_searches_create';
import './bookmarked_searches/bookmarked_searches_edit';
import '../../../directives/spinner/spinner.directive';
// Services and helpers
import '../../../angular/services/slug_and_id.service';
import '../../../../../lib/assets/javascripts/devex/util';
import '../../../../assets/javascripts/funding/funding';
import '../../../../assets/javascripts/funding/shared/date_filter.service';
import '../../../../assets/javascripts/ui_toolbox/devex.user';
import { createQueryString } from '../../../utilities/utilities';

const moduleDependencies = [
  'fundingSearchApp.models.reportApiService',
  'fundingSearchApp.services.urlHandlingService',
  'fundingSearchApp.directives.searchBar',
  'fundingSearchApp.directives.visualizationsButton',
  'fundingSearchApp.components.visualizationsContainer',
  'fundingSearchApp.services.dateFilterService',
  'fundingSearchApp.models.reportApiService',
  'directives.bookmarkedSearches',
  'services.SlugAndIdService',
  'fundingSearchApp.services.urlHandlingService',
  'directives.spinner',
  'devex.search',
  'services.SlugAndIdService',
  modal,
  accordion,
];

angular.module('fundingSearchApp.directives.container', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
    $templateCache.put(searchTipsModalTemplate, searchTipsModalTemplate);
    $templateCache.put(terminologiesModalTemplate, terminologiesModalTemplate);
  }])
  .directive('container', [
    '$filter',
    '$window',
    '$http',
    '$timeout',
    'SearchJS',
    'reportApiService',
    'bookmarkedSearchService',
    'urlHandlingService',
    'SpinnerService',
    'SlugAndIdService',
    '$uibModal',
    'dateFilterService',
    (
      $filter,
      $window,
      $http,
      $timeout,
      SearchJS,
      reportApiService,
      bookmarkedSearchService,
      urlHandlingService,
      spinner,
      SlugAndId,
      $uibModal,
      dateFilterService
    ) => {
      const link = ($scope) => {
        $scope.userSignedIn = devex.data.userSignedIn;

        $scope.dropdowns = {
          isExpandedView: false,
          isBookmarkedSearchesUp: true,
        };

        $scope.dateFilterService = dateFilterService;

        /**
         * Toggle main container expanded view
         *
         * @returns {undefined}
         */
        $scope.toggleContainerExpansion = () => {
          $scope.dropdowns.isExpandedView = !$scope.dropdowns.isExpandedView;

          // Because the bookmarkedSearches and the main container directive don't share
          // same $scope, define as a boolean the container expanded view setting in
          // bookmarkedSearchService alertSectionOptions object
          $scope.bookmarkedSearchService.alertSectionOptions.isContainerExpanded =
          $scope.dropdowns.isExpandedView;
        };

        $scope.isMobileListHidden = true;
        $scope.showVisualizations = false;
        $scope.removeReportParamFromUrl = false;
        // On the first search, a few things should behave a bit differently, e.g. we don't want to
        // overwrite the report loaded from the URL when applying first search when BookmarkedSearch
        // is being passed as param
        $scope.firstSearch = true;

        $scope.createAlertPanelOptions = {
          title: '',
          interval: '',
          isExpanded: false,
        };

        $scope.resetCreateAlertPanelOptions = () => {
          $scope.createAlertPanelOptions = {
            title: '',
            interval: '',
            isExpanded: false,
          };
        };

        $scope.userPermissions = {
          USE_FUNDING_SEARCH: false,
          ADVANCED_FUNDING_TOOLS: false,
          MANAGE_ARTICLES: false,
        };

        $scope.userCanTrackByColleagues = false;
        $scope.bookmarkedSearchService = bookmarkedSearchService;
        $scope.hideSpinner = spinner.allFlagsMarked;

        // eslint-disable-next-line
      let searchTipsModal = null;

        $scope.emptyResultsText =
        'Sorry, there are no results matching your' +
        ' search criteria. Please try to remove some keywords and filters' +
        ' to see more results.';

        $scope.showTipsModal = () => {
        // eslint-disable-next-line no-unused-vars
          searchTipsModal = $uibModal.open({
            templateUrl: searchTipsModalTemplate,
            scope: $scope,
            animation: false,
          });
        };
        // eslint-disable-next-line
      let terminologiesModal = null;

        $scope.showTerminologiesModal = () => {
        // eslint-disable-next-line no-unused-vars
          terminologiesModal = $uibModal.open({
            templateUrl: terminologiesModalTemplate,
            scope: $scope,
            animation: false,
          });
        };

        /**
         * Toggle create alert panel and generate GA event for it
         *
         * @returns {undefined}
         */
        $scope.toggleCreateAlertPanel = () => {
          bookmarkedSearchService.alertSectionOptions.isListExpanded = false;
          $scope.bookmarkedSearchService.alertSectionOptions.isCreationExpanded =
          !$scope.bookmarkedSearchService.alertSectionOptions.isCreationExpanded;
        };

        $scope.$watch('hideSpinner()', () => {
          if ($scope.hideSpinner() === true) {
            devex.funding.affixElements();
            devex.funding.resultListHeight();
            devex.funding.resultListPosition();
          }
        });

        $scope.setupSearchJs = () => {
          $scope.search = new SearchJS({
            searchUrl: '/api/funding_projects',
            defaultPageSize: 20,
          });

          // If user is allowed to see visualization load aggregation data for charts
          if ($scope.userPermissions.USE_FUNDING_SEARCH) {
            $scope.search.additionalParams = {
              aggregations: ['donors', 'countries', 'regions', 'regions_inferred', 'news_topics'],
            };
          }

          $scope.search.on('queryComplete', $scope.searchCallback);
          $scope.search.on('queryException', $scope.searchErrorCallback);
          $scope.browserUrl = devex.urls.BrowserUrl.getInstance();
          $scope.addVisualizationParam();
          $scope.addReportParam();
          $scope.addSearchJsFilters();
        };

        $scope.addReportParam = () => {
          $scope.browserUrl.addParam(
            {
              report: () => {
                if (!$scope.activeReport) {
                  return $scope.getSlugFromUrl();
                }
                return urlHandlingService.generateReportSlug($scope.activeReport);
              },
            },
            (reportSlug) => {
            // If the visualizations mode is active then we won't load the
            // report from the URL on initialization
              if ($scope.showVisualizations) {
                return;
              }

              // If there is no report ID present in the URL, open search in expanded view
              $scope.dropdowns.isExpandedView = !reportSlug;

              // Because the bookmarkedSearches and the main container directive don't share
              // same $scope, define as a boolean the container expanded view setting in
              // bookmarkedSearchService alertSectionOptions object
              $scope.bookmarkedSearchService.alertSectionOptions.isContainerExpanded =
              $scope.dropdowns.isExpandedView;

              // Wait for a reportSlug to be present before triggering the
              // loadReport function as triggering `$scope.loadReport(null)`
              // will end up in requesting `/api/funding_projects` for nothing
              if (reportSlug) {
                $scope.loadReport(urlHandlingService.extractParamsFromSlug(reportSlug));
              }
            }
          );
        };

        $scope.addVisualizationParam = () => {
          $scope.browserUrl.addParam(
            {
              visualization: () => {
                return $scope.showVisualizations;
              },
            },
            (showVisualizations) => {
              $scope.showVisualizations = showVisualizations;

              $scope.search.triggerSearchOnParamChange = !showVisualizations;
            },
            false
          );
        };

        /**
         * It returns 'All Time' when no time filter is set, a date in a correct format
         * when user selects a custom date or pre-defined time spans e.g Last 24h or Last week
         *
         * @returns {string} - Text to be displayed on the `Updated` dropdown
         */
        $scope.showFilterTimeValue = () => {
          if (dateFilterService.getState().last_day) {
            return 'Last 24h';
          } else if (dateFilterService.getState().last_week) {
            return 'Last week';
          } else if (dateFilterService.getState().last_month) {
            return 'Last month';
          } else if (dateFilterService.getState().custom_date) {
            return $filter('date')($scope.search.filter.updated_since.value, 'mediumDate');
          }
          return 'All time';
        };

        $scope.updatedSinceAggregations = {
          lastUrl: null,
          loading: false,
          values: {
            last_day: null,
            last_week: null,
            last_month: null,
            all_time: null,
          },
        };

        /**
         * Iterate over aggregations received from the api and return an object
         * where each key corresponds the the aggregation value.
         *
         * @param {Array} data -  aggregation data from the api
         * @returns {object} - new updatedSinceAggregations state
         */
        $scope.mapUpdatedSinceAggregations = (data) => {
          const aggregations = {};
          data.forEach((item) => {
            aggregations[item.key] = item.value;
          });
          return aggregations;
        };

        /**
         * Makes a get request to the funding search endpoint requesting only
         * aggregations for the updated_since filter. Saves the result, so it can
         * be displayed in the time filter. Only makes a new query if the current
         * filters have changed. Shows error alert if something goes wrong.
         *
         * @returns {undefined}
         */
        $scope.getUpdatedSinceAggregations = () => {
          const timeAggregationSearch = angular.copy($scope.search);
          timeAggregationSearch.additionalParams = { aggregations: ['updated_since'] };
          timeAggregationSearch.pagination.pageSize = 0;
          timeAggregationSearch.filter.updated_since.setValue(null);
          const url = timeAggregationSearch.getURL();

          if (url === $scope.updatedSinceAggregations.lastUrl) {
            return;
          }

          $scope.updatedSinceAggregations.loading = true;
          $http.get(url).then(
            (resp) => {
              $scope.updatedSinceAggregations.values = $scope.mapUpdatedSinceAggregations(
                resp.data.aggregations.updated_since
              );
              $scope.updatedSinceAggregations.lastUrl = url;
              $scope.updatedSinceAggregations.loading = false;
            },
            () => {
              $scope.updatedSinceAggregations.loading = false;
            }
          );
        };

        /**
         * Add a series of filter to SearchJs instance
         *
         * @returns {undefined}
         */
        $scope.addSearchJsFilters = function () {
          $scope.search.addFilter({
            name: 'query',
            isArray: true,
            attachToRoot: true,
          });
          $scope.search.addFilter({
            name: 'organization_ids',
            isArray: true,
            setValue: function (params) {
              this.value = params;
            },
          });
          $scope.search.addFilter({
            name: 'news_topics',
            isArray: true,
            getValue: function () {
              return this.value.map(function (value) {
                return value.name;
              });
            },
            setValue: function (params) {
              this.value = params.map(function (param) {
                return { name: param };
              });
            },
          });
          $scope.search.addFilter({
            name: 'donors',
            isArray: true,
            default: [],
            getValue: function () {
              return this.value.map((value) => value.short_name);
            },
            setValue: function (params) {
              this.value = params.map((param) => {
                return { short_name: param };
              });
            },
            removeValue: function (shortName) {
              const donor = this.value.find((item) => item.short_name === shortName);

              if (donor) {
                const index = this.value.indexOf(donor);
                this.value.splice(index, 1);
              }
            },
          });
          $scope.search.addFilter({
            name: 'exclude_donors',
            isArray: true,
            default: [],
            getValue: function () {
              return this.value.map((value) => value.short_name);
            },
            setValue: function (params) {
              this.value = params.map((param) => {
                return { short_name: param };
              });
            },
            removeValue: function (shortName) {
              const donor = this.value.find((item) => item.short_name === shortName);

              if (donor) {
                const index = this.value.indexOf(donor);
                this.value.splice(index, 1);
              }
            },
          });

          $scope.search.addFilter({
            name: 'donor_categories',
            isArray: true,
            default: [],
            getValue: function () {
              return this.value.map((value) => value.name);
            },
            setValue: function (params) {
              this.value = params.map((param) => {
                return { name: param };
              });
            },
            removeValue: function (name) {
              const donorCategory = this.value.find((item) => item.name === name);

              if (donorCategory) {
                const index = this.value.indexOf(donorCategory);
                this.value.splice(index, 1);
              }
            },
          });

          $scope.search.addFilter({
            name: 'places',
            isArray: true,
            default: [],
            getValue: function () {
              return this.value.map((value) => value.name);
            },
            setValue: function (params) {
              this.value = params.map((param) => {
                return { name: param };
              });
            },
          });

          $scope.search.addFilter({
            name: 'type',
            isArray: true,
            reportTypes: [
              'tender',
              'grant',
              'open_opportunity',
              'pipeline',
              'funding_info',
              'contract',
              'shortlist',
            ],
            default: [],
          });
          $scope.search.addFilter({
            name: 'opportunity_sizes',
            isArray: true,
            reportTypes: ['tender', 'grant', 'open_opportunity', 'pipeline'],
          });
          $scope.search.addFilter({
            name: 'categories',
            isArray: true,
            reportTypes: ['tender', 'grant', 'open_opportunity', 'pipeline'],
          });
          $scope.search.addFilter({
            name: 'statuses',
            isArray: true,
            reportTypes: ['tender', 'grant', 'open_opportunity', 'pipeline'],
          });
          $scope.search.addFilter({
            name: 'deadline',
            reportTypes: ['tender', 'grant', 'open_opportunity'],
          });
          $scope.search.addFilter({
            name: 'updated_since',
            reportTypes: [
              'tender',
              'grant',
              'open_opportunity',
              'pipeline',
              'funding_info',
              'contract',
              'shortlist',
            ],
          });
          $scope.search.addFilter({
            name: 'source_type',
            isArray: true,
            reportTypes: ['funding_info'],
          });

          // TRACK BUTTON
          $scope.search.addFilter({
            name: 'tracked_by_me',
            default: false,
          });
          $scope.search.addFilter({
            name: 'tracked_by_colleagues',
            default: false,
          });

          $scope.search.addFilter({
            name: 'ca_type',
            isArray: true,
            reportTypes: ['contract', 'shortlist'],
            default: ['contract', 'shortlist'],
          });

          // SORTING
          $scope.sortingOptions = {
            updated_at: {
              searchJsParams: { field: 'updated_at', order: 'desc' },
              label: 'Publication date',
            },
            _score: {
              searchJsParams: { field: '_score', order: 'desc' },
              label: 'Relevance',
            },
          };

          $scope.filterOptionsTime = {
            last_24h: {
              name: 'Last 24h',
              key: 'last_day',
            },
            last_week: {
              name: 'Last week',
              key: 'last_week',
            },
            last_month: {
              name: 'Last month',
              key: 'last_month',
            },
            no_time: {
              name: 'All time',
              key: 'all_time',
            },
          };
        };

        /**
         * Sets sorting option's filter of main `$scope.search`
         *
         * @param {object} option                       -  Sorting option to be applied
         * @param {string} option.label                 -  Label sorting option
         * @param {string} option.searchJsParams.field  -  Field sorting option
         * @param {string} option.searchJsParams.order  -  Order sorting option
         *
         * @returns {undefined}
         */
        $scope.addSortOption = (option) => {
          $scope.search.sorting.setParams({ sorting: option.searchJsParams });
          $scope.search.notifyParamChange();
        };

        /**
         * Overwrite the type and/or status filters of searchJS, only if they
         * are not active in that moment, and set sorting to default value.
         *
         * @param {boolean} [overwriteActiveFilters] Optional - If true, it
         * first resets all SearchJs filters to their default values and then,
         * sets the type and status filters to predefined values. This method
         * does not trigger any search.
         *
         * @returns {undefined}
         */
        $scope.applyFallbackFilters = (overwriteActiveFilters) => {
          const statuses = $scope.search.filter.statuses;

          if (overwriteActiveFilters) {
            $scope.search.reset();
            statuses.setValue(['forecast', 'open']);
          } else {
          // Set statuses statuses filter in order to exclude closed, postponed
          // and cancelled reports if status filter is not active on init
            if (!statuses.isActive()) {
              statuses.setValue(['forecast', 'open']);
            }
          }
          $scope.search.sorting.setParams({
            sorting: $scope.sortingOptions.updated_at.searchJsParams,
          });
        };

        /**
         * It forces detect incoming URL sorting options params.
         * If incoming `sorting[field]` param is present in the URL, it sets it accordingly.
         * If there is no param, it sorts by `Publication date` (default sorting).
         *
         * @returns {undefined}
         */
        const sortingParamsDetection = () => {
          const incomingFilters = devex.urls.getParams();

          if (
            incomingFilters.sorting &&
          incomingFilters.sorting.field &&
          $scope.sortingOptions[incomingFilters.sorting.field]
          ) {
            $scope.search.sorting.setParams({
              sorting: $scope.sortingOptions[incomingFilters.sorting.field].searchJsParams,
            });
          } else {
            $scope.search.sorting.setParams({
              sorting: $scope.sortingOptions.updated_at.searchJsParams,
            });
          }
        };

        $scope.setupPageTitle = () => {
          $scope.originalPageTitle = $window.document.title;
          $scope.$watch('activeReport', () => {
            if ($scope.activeReport && $scope.activeReport.title) {
              $window.document.title =
              devex.util.htmlToPlaintext($scope.activeReport.title) +
              ' | ' +
              $scope.originalPageTitle;
            } else {
              $window.document.title = $scope.originalPageTitle;
            }
          });
        };

        /**
         * Set up SearchJs instance and title of the page, apply fallback filters, if
         * showVisualizations mode is disabled, run a first reports search
         *
         * @returns {undefined}
         */
        $scope.finishInit = () => {
          $scope.setupSearchJs();
          $scope.setupPageTitle();
          $scope.applyFallbackFilters();
          sortingParamsDetection();

          // If visualization mode is OFF:
          //   - If user is signed in, initialize bookmarkSearchService to monitor possible incoming
          //     bookmarked_search_id in URL. Add $$scope.$watch to trigger searchJs once
          //     bookmarkSearchService URL manipulation is fully finished
          //         - If user is premium, do not load a first report, load visualizations instead
          //         - If user is not premium, load first report from results
          //
          //   - If user is not signed in, do not init bookmarkedSearchService, trigger searchJs.
          if (!$scope.showVisualizations) {
            if ($scope.userSignedIn) {
              $scope.bookmarkedSearchService.startInit();
              $scope.$watch('bookmarkedSearchService.triggerSearchJs', (value) => {
                if (value) {
                  $scope.search.search();
                }
              });
            } else {
              $scope.search.search();
            }

            if ($scope.userPermissions.USE_FUNDING_SEARCH) {
            // Since premium users should see the visualizations instead of the first report,
            // there is nothing else to wait for.
              spinner.markAsInitialized();
            } else {
              spinner.addFlags({
                report: false,
              });
            }

          // If visualization mode is ON:
          //   - Mark spinner as initialized to hide spinner right away. Visualization container
          //   will take care of performing request for visualizations.
          } else {
            spinner.markAsInitialized();
          }

          // TRACK BUTTON
          const filters = $scope.search.filter;

          $scope.isTrackedReportsActive = {
            me: filters.tracked_by_me.getValue(),
            colleagues: filters.tracked_by_colleagues.getValue(),
          };

          $scope.dateFilterService.init($scope.search);
        };

        /**
         * Returns if it is the first triggered search when landing on the page and there is an
         * active bookmarkedSearch
         *
         * @returns {boolean} - true if it is the first bookmarked searches search, false otherwise
         */
        $scope.isFirstBookmarkedSearchFn = () => {
          return $scope.bookmarkedSearchService.active.id && $scope.firstSearch;
        };

        /**
         * Do not apply bookmarked search any more, unset active report and apply search default
         * filters
         *
         * @returns {undefined}
         */
        $scope.exitAppliedAlert = () => {
        // This hide the Exit alert button
          $scope.bookmarkedSearchService.active = {};
          $scope.bookmarkedSearchService.alertSectionOptions.isBookmarkedSearchApplied = false;
          $scope.bookmarkedSearchService.alertSectionOptions.isEditionExpanded = false;

          $scope.applyFallbackFilters(true);
          $scope.bookmarkedSearchService.reloadSearchJs($scope.search);
        };

        /**
         * Performs some actions when SearchJs finishes successfully
         * Removes activeReport if any filter on visualization has been applied
         * If there is no activeReport, selects first report from the list for if user does not
         * have permissions USE_FUNDING_SEARCH
         *
         * @returns {undefined}
         */
        $scope.searchCallback = () => {
          if ($scope.removeReportParamFromUrl) {
            $scope.activeReport = null;
          }

          if ($scope.bookmarkedSearchService.active.id) {
            $scope.getUpdatedSinceAggregations();
          }

          if (!$scope.userPermissions.USE_FUNDING_SEARCH) {
            if (!$scope.activeReport && !$scope.loadingActiveReport) {
              const report = $scope.search.results[0];
              if (report) {
                $scope.loadReport({ type: report.type, id: report.id });
              }
            }
          }

          $scope.firstSearch = false;

          $scope.$apply();
        };

        $scope.searchErrorCallback = (error) => {
          var url = document.location.href;
          var urlLength = url.length;
          if (error.status === 0 && urlLength > 2000) {
            devex.alerts.showAlert(
            // eslint-disable-next-line max-len
              'Sorry, your search parameters are exceeded. Please adjust the amount of selected Donors. You can use the included / excluded toggles in the Funder categories.',
              'error',
              { sticky: true }
            );
          } else {
            devex.alerts.showAlert('Sorry, something went wrong. Please try again.', 'error');
          }
        };

        /**
         * Merge the query filter (if any) EVERY time we load report with the
         * required params of the details endpoint to let the BE generate
         * keywords highlighting
         *
         * @param {object} params - Search params {id, type}
         * @param {number} params.id - The Id of the report we want to load
         * @param {string} params.type - The type of the report we want to load
         *
         * @returns {object} Search params and search_query if exists {id, type, search_query}
         */
        $scope.mergeSearchQuery = (params) => {
        // On page load, if incoming report and query params in URL, BrowserUrl
        // triggers the details request before searchJs filters are actually
        // applied (the report param here is dealt with BrowserUrl).
        // This fix allows us to send the search_query param even if searchJs
        // is not loaded

          params.search_query = devex.urls.getParams().query || '';
          if (
            params.search_query === '' &&
          $scope.search.filter.query &&
          $scope.search.filter.query.isActive()
          ) {
            params.search_query = $scope.search.filter.query.getValue().toString();
          }
          return params;
        };

        /**
         * Grabbing the report slug from the URL
         *
         * @returns {null | string} report slug if exists, null if does not
         */
        $scope.getSlugFromUrl = () => {
          const params = $scope.browserUrl.getDefinedParams();
          const report = params.find((item) => item.identifier === 'report');
          const slug = report.getUrlValueOrDefault();
          return slug;
        };

        /**
         * If the URL has UTM params, it returns those params,
         * otherwise, it returns an empty string
         *
         * @returns {string} - UTM key value pairs or empty string
         */
        $scope.getUTMParams = () => {
          const searchParams = new URLSearchParams(window.location.search);
          let UTMParams = '';

          for (const [key, value] of searchParams) {
            if (key.includes('utm_')) {
              if (!UTMParams) {
                UTMParams += `?${key}=${value}`;
              } else {
                UTMParams += `&${key}=${value}`;
              }
            }
          }

          return UTMParams;
        };

        /**
         * Performs an AJAX request to retrieve the report's details
         *
         * @param {object} params - an object with properties
         * @param {number} params.id - The Id of the report we want to load
         * @param {string} params.type - The type of the report we want to load
         * @param {Function} [callback] optional - Callback executed on
         * request's success
         *
         * @returns {undefined}
         *
         */
        $scope.loadReport = (params, callback) => {
          const UTMParams = $scope.getUTMParams();
          $scope.loadingActiveReport = true;

          reportApiService.get($scope.mergeSearchQuery(params)).$promise.then(
            (data) => {
              const { funding_project, paywall_url } = data;
              $scope.reportDetailsError = null;
              $scope.activeReport = funding_project;
              $scope.loadingActiveReport = false;
              $scope.paywallUrl = paywall_url;
              $scope.browserUrl.updateUrl();

              $scope.activeReport.places.forEach((place) => {
                if (place.has_page) {
                  place.slug_and_id = SlugAndId.createSlugAndId(place.name, place.id);
                }
              });

              if (window.plausible && typeof window.plausible === 'function') {
                window.plausible('pageview', {
                  u:
                  window.location.origin +
                  '/funding/' +
                  funding_project.type +
                  '/' +
                  funding_project.id +
                  UTMParams,
                  props: {
                    content_id: funding_project.id,
                    content_type: funding_project.type,
                    paywall: paywall_url ? 'PFO' : 'none',
                  },
                });
              }

              if (callback) {
                callback();
              }

              spinner.markFlag('report');
            },
            () => {
              spinner.markFlag('report');
              $scope.loadingActiveReport = false;
              $scope.reportDetailsError = 'We were not able to load the report. Please try again';
            }
          );
        };

        $scope.getTypeFilterValues = () => {
          if ($scope.search) {
            return $scope.search.filter.type.value.map((value) => {
              if (value === 'funding_info') {
                return devex.util.humanize(devex.funding.titleDisplay(value), { titleize: true });
              }
              return devex.util.humanize(
                devex.util.classToRestPlural(devex.funding.titleDisplay(value)),
                {
                  titleize: true,
                }
              );
            });
          }
        };

        $scope.scrollToTop = () => {
          devex.uiUtils.scrollToTop('#over-top-of-list');
          $('.search-results-container').animate({ scrollTop: 0 }, 500);
        };

        $scope.scrollDetailToTop = () => {
          devex.uiUtils.scrollToTop('#over-top-of-list');
        };

        $scope.scrollToTopMobile = () => {
          devex.uiUtils.scrollToTop('#xs-top-of-list');
          $('.search-results-container').animate({ scrollTop: 0 }, 500);
          if (devex.util.isMobile()) {
            $('.search-container').css({ height: $('.result-list').outerHeight() });
          }
        };

        /**
         * Scroll back to the top of the page, used when new filters are applied
         * or page is changed.
         * If there is an active report we want to keep it selected
         *
         * @returns {undefined}
         **/
        $scope.onPageChange = () => {
          $scope.scrollToTop();
          $scope.removeReportParamFromUrl = false;
          $scope.search.search();
        };

        /**
         * Return true/false whether or not the active element is an input
         * element or a text area.
         *
         * @returns {boolean} - true if the active element is an input or text area, false otherwise
         */
        $scope.focusIsOnInput = () => {
          const el = document.activeElement;
          // return false unless an element is present
          // true if any input
          // or text field is active
          return !!(
            (el && el.tagName.toLowerCase() === 'input') ||
          el.tagName.toLowerCase() === 'textarea'
          );
        };

        /**
         * Some of the logic of this application relies on emitted events. In this function, we try
         * to have all this logic held in one place.
         *
         * @returns {undefined}
         */
        $scope.attachEventListeners = () => {
        // User presses right arrow, keyCode is 39
          $scope.$on('keypress:39', (event) => {
            if (!$scope.focusIsOnInput()) {
              $scope.selectNextReport();
              event.preventDefault();
            }
          });
          // User presses left arrow, keyCode is 37
          $scope.$on('keypress:37', (event) => {
            if (!$scope.focusIsOnInput()) {
              $scope.selectPreviousReport();
              event.preventDefault();
            }
          });

          // When a reports is selected in the search results list
          $scope.$on('result.selected', (event, report) => {
            $scope.loadReport({ type: report.type, id: report.id }, $scope.scrollDetailToTop);
            if (devex.util.isMobile()) {
              $('.search-container').css({ height: 'auto' });
            }
            $scope.isMobileListHidden = !$scope.isMobileListHidden;
          });
        };

        // Hereunder we do a parseInt of the report.id because currently, the ID
        // of the items of $scope.search.results is a String. This might change
        // in the future, as having ID's as string is not ideal.
        // This methods works in both cases: if the ID is a string or
        // an int.
        $scope.getActiveReportIndex = () => {
          const reportIds = $scope.search.results.map((report) => parseInt(report.id));
          return reportIds.indexOf($scope.activeReport.id);
        };

        $scope.selectNextReport = () => {
          const currentReportIndex = $scope.getActiveReportIndex();
          if (currentReportIndex + 1 >= $scope.search.results.length) {
            return $scope.activeReport;
          }
          const report = $scope.search.results[currentReportIndex + 1];
          $scope.loadReport(
            { type: report.type, id: report.id },
            // scroll list up
            () => {
              $('.search-results-container').animate({ scrollTop: '+=75px' }, 0);
            }
          );
        };

        $scope.selectPreviousReport = () => {
          const currentReportIndex = $scope.getActiveReportIndex();
          if (currentReportIndex - 1 < 0) {
            return $scope.activeReport;
          }
          const report = $scope.search.results[currentReportIndex - 1];
          $scope.loadReport({ type: report.type, id: report.id }, () => {
            $('.search-results-container').animate({ scrollTop: '-=75px' }, 0);
          });
        };

        /*
       * VISUALIZATIONS
       */
        $scope.toggleVisualizations = () => {
        // Allow/disallow searchJs to trigger requests when params change
        // depending on the visualization status;
        // showVisualizations = disallow, !showVisualizations = allow
          $scope.search.triggerSearchOnParamChange = $scope.showVisualizations;
          // If we're showing visualizations and we're going to hide them
          // we'll perform a search and a detail request because
          // we don't know if the filters have changed since the visualization
          // mode was enabled
          if ($scope.showVisualizations) {
          // If we have no active report (accessing directly to
          // visualizations by URL)
            if (!$scope.activeReport) {
              const slug = $scope.getSlugFromUrl();
              // If there is a report in the URL then we grab the slug and
              // perform the search for this report and make sure it remains on the url
              if (slug) {
                $scope.loadReport(urlHandlingService.extractParamsFromSlug(slug));
              }
            }
            $scope.search.search();
          } else {
            $scope.removeReportParamFromUrl = false;
          }

          // Hide visualizations container and toggle button interface
          $scope.showVisualizations = !$scope.showVisualizations;

          if ($scope.showVisualizations) {
            if (window.plausible && typeof window.plausible === 'function') {
              window.plausible(
                'pageview', { u: window.location.origin + '/funding/visualization' }
              );
            }
          }

          // browserUrl remove visualization=true from URL
          $scope.browserUrl.updateUrl();
        };

        /*
       * TRACK BUTTON
       */
        $scope.toggleTracked = (type) => {
          const filter = $scope.search.filter[`tracked_by_${type}`];
          const newValue = !filter.value;

          filter.setValue(newValue);
          $scope.search.notifyParamChange();
          $scope.isTrackedReportsActive[type] = newValue;
        };

        /**
         * Updates `tracked_by_me` value
         *
         * If it is filtering by `tracked_by_me` it directly triggers a new search and returns.
         *
         * When tracking from 'detail' page it sets targetReport from the list
         * When tracking from 'list' page it sets targetReport from the activeReport (if existing)
         *
         * @param {object} report - tracked report
         *
         * @returns {undefined}
         */
        $scope.toggleTrackReport = (report) => {
          let targetReport;

          if ($scope.search.filter.tracked_by_me.getValue()) {
            $scope.search.notifyParamChange();
            return;
          }

          targetReport = $scope.search.results.find((item) => parseInt(item.id) === report.id);

          if (targetReport) {
            targetReport.tracked_by_me = report.tracked_by_me;
          }
        };

        $scope.resultExportPath = (format) => {
          const queryParams = $scope.search.getParams({
            includeSorting: true,
            includeFilter: true,
          });

          return `/api/funding_projects/export.${format}${createQueryString(queryParams)}`;
        };

        /**
         * Initialize the directive
         *
         * @returns {undefined}
         */
        const initializeContainer = () => {
          $scope.finishInit();
          $scope.attachEventListeners();
        };

        /**
         * Defines users permissions checking the user privileges.
         *
         * @returns {undefined}
         */
        const checkPermissions = () => {
          $scope.userCanTrackByColleagues = devex.user.company_id !== null;
          const userId = devex.data.user.id;
          const privileges = ['USE_FUNDING_SEARCH', 'ADVANCED_FUNDING_TOOLS', 'MANAGE_ARTICLES'];
          let promises = [];

          privileges.forEach((privilege) => {
            promises.push(
              new Promise((resolve, reject) => {
              // eslint-disable-next-line max-len
                const endpointUrl = `/api/permissions/${privilege}/${userId}${createQueryString({charge_credits: false})}`;
                $http.get(endpointUrl).then(
                  (response) => {
                    resolve(response.data.allowed || false);
                  },
                  () => {
                    reject(false);
                  }
                );
              })
            );
          });

          return new Promise((resolve) => {
            Promise.all(promises).then((resolved) => {
              const [USE_FUNDING_SEARCH, ADVANCED_FUNDING_TOOLS, MANAGE_ARTICLES] = resolved;

              resolve({
                USE_FUNDING_SEARCH,
                ADVANCED_FUNDING_TOOLS,
                MANAGE_ARTICLES,
              });
            });
          });
        };

        /**
         * If session ID is a string, wait for devex.user object to be
         * present by running devex.user.getData() request (that will then
         * chain callback to the existing request, triggered by userMenu)
         *
         * If session ID is null (UA user), we shouldn't run `devex.user.getData()` as
         * this would return a 400 and would be useless.
         *
         * @returns {undefined}
         */
        $scope.init = () => {
          if (devex.data.userSignedIn) {
            devex.user.getData(() => {
              checkPermissions().then((userPermissions) => {
                $timeout(function () {
                  $scope.userPermissions = userPermissions;
                  initializeContainer();
                }, 0);
              });
            });
          } else {
            initializeContainer();
          }
        };

        $scope.init();
      };

      return {
        restrict: 'E',
        templateUrl: template,
        scope: {
          csrfToken: '@',
        },
        link,
      };
    },
  ]);
